import React, {useEffect, useState} from "react"
import {Flex} from "antd";
import {TimerProps} from "./Timer.props";
import {Color} from "../../../../themes";
import {MyText} from "../../../common/MyText/MyText";

export const Timer = React.memo(({minutes, onCompleted}: TimerProps) => {
  const [timeLeft, setTimeLeft] = useState<number>(minutes * 60);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime === 0) {
          clearInterval(timer);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [minutes, onCompleted]);

  useEffect(() => {
    if (timeLeft === 0 && onCompleted) {
      onCompleted();
    }
  }, [timeLeft, onCompleted]);

  const hourLeft = Math.floor(timeLeft / 3600);
  const minutesLeft = Math.floor(timeLeft / 60)
  const secondsLeft = timeLeft % 60
  const formattedTime = `${hourLeft.toString().padStart(2, '0')}:${minutesLeft.toString().padStart(2, '0')}:${secondsLeft.toString().padStart(2, '0')}`

  const getColor = () => {
    if(timeLeft <= ((minutes * 60) / 3)){
      return {
        color: '#F32D2D',
        bg: '#FDDFDF'
      }
    }

    else if(timeLeft <= ((minutes * 60) / 2)){
      return {
        color: '#EA580C',
        bg: '#FFEDD5'
      }
    }


    else {
      return {
        color: Color.link,
        bg: 'rgba(24, 144, 255, 0.1)'
      }
    }
  }

  return (
    <Flex style={{
      padding: '8px',
      minWidth: 150,
      background: getColor().bg,
    }} align='middle' justify='center' flex={1}>
      <MyText color={getColor().color} size={20} weight={700}>
        {formattedTime}
      </MyText>
    </Flex>
  )
})